import React, { PropsWithChildren, RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../translation/namespace';
import { InputProps, SpanProps } from '../../types/HtmlProps';

type FormUploadZoneProps = {
  labelTitle: string;
  inputProps: InputProps & { multiple?: boolean };
  dropzoneText?: string;
  labelProps?: SpanProps;
  buttonLabelRef?: RefObject<HTMLLabelElement | null>
};

/**
 * Renders the drop zone.
 * Markup: this is a visually transparent <input type="file"> layered over the visual drop zone.
 * Trick: this enables the possibility to drag & drop stuff there.
 * @param children
 * @param dropzoneText
 * @param labelTitle
 * @param labelProps
 * @param inputProps
 * @param buttonLabelRef
 * @constructor
 */
export function FileUpload({
  children,
  dropzoneText,
  labelTitle,
  labelProps,
  inputProps,
  buttonLabelRef,
}: PropsWithChildren<FormUploadZoneProps>) {
  const { t } = useTranslation(Namespace.FileUpload);

  return (
    <div className="file-upload">
      <div className="file-upload__dropzone">
        <span className="file-upload__dropzone-text" aria-hidden>
          {dropzoneText || (inputProps.multiple ? t('dropzoneTextPlural') : t('dropzoneText'))}
        </span>
        <input className="file-upload__input" {...inputProps} />
        <label ref={buttonLabelRef} className="file-upload__label" htmlFor={inputProps.id}>
          <span className="file-upload__button" tabIndex={0} role="button" {...labelProps}>
            <span className="btn__text">{labelTitle}</span>
          </span>
        </label>
      </div>
      {children}
    </div>
  );
}
